import { Partners } from './enums.js';

export type ServiceProviderType = 'IA' | 'VT' | 'AT' | 'CT' | 'BC';

export const partnerCodeToServiceProviderType: Partial<Record<Partners, ServiceProviderType>> = {
  [Partners.ENROLY_IA]: 'IA',
  [Partners.ENROLY_VT]: 'VT',
  [Partners.ENROLY_AT]: 'AT',
  [Partners.ENROLY_CT]: 'CT',
  [Partners.ENROLY_BC]: 'BC',
};

export const getServiceProviderType = (partnerCode: string | undefined | null): ServiceProviderType | undefined => {
  if (!partnerCode) return undefined;
  return partnerCodeToServiceProviderType[partnerCode as Partners];
};
